export default "__VITE_ASSET__DQR1tcXE__"